export default "__VITE_ASSET__e9f8d19b__"